import React from "react";
import { Outlet } from "react-router-dom";

import Footer from "../bundel/Footer";
import Navbar from "../bundel/Navbar";

/**
 * App shell: sticky Navbar on top, routed content, then the Footer.
 * The content area is at least a full viewport tall (min-h-screen) so the
 * footer always sits below the fold — you scroll to reach it, even on short
 * pages.
 */
function AppLayout() {
  return (
    <div className="flex flex-col">
      <Navbar />
      <main className="bg-fairgray min-h-screen">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default AppLayout;
